export default {
  title: 'Transport Plan',
  pageTitles: {
    detail: 'Transport Plan Detail',
    edit: 'Edit Transport Plan'
  },
  list: {
    filterTitle: 'Transport Plan Filters',
    exportTitle: 'Transport Plan List'
  },
  tabs: {
    basic: 'Basic Info',
    tracking: 'Tracking',
    fee: 'Fees'
  },
  actions: {
    detail: 'Details',
    edit: 'Edit',
    operationHistory: 'Operation History',
    cancel: 'Cancel',
    save: 'Save',
    print: 'Print',
    split: 'Split',
    generateConsignment: 'Generate Transport Consignment',
    confirmGenerate: 'Confirm Generate',
    addPlan: '+ Add Plan',
    removePlan: '- Delete Plan',
    confirmSplit: 'Confirm Split'
  },
  common: {
    yes: 'Yes',
    no: 'No',
    noData: 'No Data',
    noProductData: 'No Product Data',
    noTrackingRecords: 'No Tracking Records',
    noFeeData: 'No Fee Data',
    noOperationRecords: 'No Operation Records',
    noConsignmentDetail: 'No Consignment Detail Data'
  },
  sections: {
    orderBase: 'Order Basic Info',
    logistics: 'Logistics Info',
    packageWeightVolume: 'Packages, Weight and Dimensions',
    businessTags: 'Business Custom Tags',
    productInfo: 'Product Info'
  },
  fields: {
    planNo: 'Transport Plan No.',
    planNoShort: 'Plan No.',
    orderStatus: 'Main Status',
    orderStatusDetail: 'Order Status',
    createStatus: 'Sub-consignment Status',
    transportSegment: 'Transport Segment',
    segmentOrigin: 'Segment Origin',
    segmentDestination: 'Segment Destination',
    mainlineOriginCountry: 'Mainline Origin Country',
    mainlineDestCountry: 'Mainline Destination Country',
    portOfLoading: 'Port of Loading',
    portOfDischarge: 'Port of Discharge',
    fhNo: 'Related Shipping Request No.',
    businessCategory: 'Business Category',
    fhCateg: 'Business Category Code',
    fhCategName: 'Business Category Name',
    regionCodePath: 'Region Code',
    regionPath: 'Region',
    costCenter: 'Cost Center Code',
    costCenterName: 'Cost Center',
    salesType: 'Sales Mode Code',
    salesTypeName: 'Sales Mode Name',
    bizDept: 'Business Department Code',
    departmentName: 'Business Department',
    fhNoShort: 'Related FH No.',
    fhNoDetail: 'Related FH No.',
    wtNo: 'Related Transport Consignment No.',
    wtNoDetail: 'Transport Consignment No.',
    goodsType: 'Goods Info',
    cusShortName: 'Customer Short Name',
    cusNo: 'Customer Code',
    createdAt: 'Created Time',
    creator: 'Creator',
    updatedAt: 'Updated Time',
    updater: 'Updater',
    omsRemark: 'Order Remark',
    logisticsOperator: 'Logistics Operator',
    tradeChain: 'Trade Chain',
    customsTradeTerm: 'Trade Term (Customs)',
    clearanceTradeTerm: 'Trade Term (Clearance)',
    transportTerms: 'Transport Terms',
    crossBorder: 'Cross-border',
    logisticsDirection: 'Logistics Direction',
    customerConsignment: 'Customer Appointed',
    segmentTransportMode: 'Segment Transport Business Type',
    carrier: 'Carrier',
    consignmentNo: 'Consignment No.',
    waybillNo: 'Waybill/B/L No.',
    destinationWh: 'Destination Warehouse',
    destinationWhCode: 'Destination Warehouse Code',
    expectShipDate: 'Expected Shipping Time',
    expectDepartureTime: 'Expected Departure Time (ETD)',
    actShipDate: 'Actual Shipping Time',
    actualShipTime: 'Actual Shipping Time',
    expectArrivalDate: 'Expected Arrival Time',
    expectArrivalTime: 'Expected Arrival Time (ETA)',
    actArrivalDate: 'Actual Arrival Time',
    actualArrivalTime: 'Actual Arrival Time',
    hsCode: 'HS Code',
    originCountry: 'Country of Origin',
    tmsRemark: 'Transport Remark',
    bizTags: 'Business Tags',
    currentTrackingNode: 'Current Tracking Node',
    actions: 'Actions',
    warehouse: 'Shipping Warehouse'
  },
  placeholders: {
    planNo: 'Enter transport plan no.; separate multiple values with comma/space',
    fhNo: 'Enter related shipping request no.; separate multiple values with comma/space',
    transportSegment: 'Select transport segment',
    segmentTransportMode: 'Select transport business type',
    orderStatus: 'Select main status',
    createStatus: 'Select sub-consignment status',
    segmentOrigin: 'Select segment origin',
    segmentDestination: 'Select segment destination',
    destinationWh: 'Select destination warehouse',
    destinationWhCode: 'Select destination warehouse code',
    mainlineOriginCountry: 'Select mainline origin country',
    mainlineDestCountry: 'Select mainline destination country',
    portOfLoading: 'Enter port of loading code',
    portOfDischarge: 'Enter port of discharge code',
    currentTrackingNode: 'Enter current tracking node',
    cusShortName: 'Enter customer short name',
    cusNo: 'Enter customer code',
    createdAt: 'Select created time',
    creator: 'Enter creator',
    omsRemark: 'Enter order remark',
    logisticsOperator: 'Enter logistics operator ID',
    updatedAt: 'Select updated time',
    tradeChain: 'Enter trade chain',
    customsTradeTerm: 'Select trade term (customs)',
    clearanceTradeTerm: 'Select trade term (clearance)',
    tradeTerm: 'Select trade term',
    transportTerms: 'Select transport terms',
    crossBorder: 'Select cross-border',
    logisticsDirection: 'Select logistics direction',
    customerConsignment: 'Select customer appointed',
    goodsType: 'Select goods info',
    wtNo: 'Enter related transport consignment no.',
    expectShipDate: 'Select expected shipping time',
    actShipDate: 'Select actual shipping time',
    expectArrivalDate: 'Select expected arrival time',
    actArrivalDate: 'Select actual arrival time',
    hsCode: 'Enter HS code',
    originCountry: 'Select country of origin',
    tmsRemark: 'Enter transport remark',
    bizTags: 'Enter business tags',
    bizTagsSelect: 'Enter or select business tags'
  },
  enums: {
    transportSegment: {
      prePort: 'Pre-carriage',
      main: 'Main Leg',
      final: 'Final Leg',
      full: 'End-to-end'
    },
    orderStatus: {
      created: 'Created',
      reviewed: 'Reviewed',
      operating: 'Operating',
      completed: 'Completed',
      frozen: 'Frozen',
      cancelled: 'Cancelled'
    },
    createStatus: {
      notCreated: 'Not Created',
      created: 'Created'
    },
    mergeStatus: {
      notMerged: 'Not Merged',
      merged: 'Merged'
    },
    transportMode: {
      fcl: 'Ocean FCL',
      lcl: 'Ocean LCL',
      air: 'Air',
      road: 'Road',
      rail: 'Rail',
      express: 'Express',
      other: 'Other'
    },
    logisticsDirection: {
      forward: 'Forward',
      reverse: 'Reverse'
    },
    goodsType: {
      standard: 'Standard Product',
      marketing: 'Marketing Material',
      rawMaterial: 'Raw Material',
      gift: 'Gift'
    }
  },
  weightVolume: {
    dataSource: 'Data Source',
    totalQty: 'Total Qty',
    totalVolume: 'Total Volume',
    totalWeight: 'Total Weight',
    chargeableWeight: 'Chargeable Weight',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    expected: 'Expected',
    warehouse: 'Warehouse Data',
    supplier: 'Forwarder Data'
  },
  productColumns: {
    index: 'No.',
    skuCode: 'SKU/Material Code',
    productName: 'Product Name',
    productModel: 'Product Model',
    brand: 'Brand',
    specialAttributes: 'Special Product Attributes',
    barCode: 'UPC Barcode',
    pcsQty: 'Qty',
    boxGauge: 'Outer Box Spec',
    stdBoxQty: 'Std. Cartons',
    actualBoxQty: 'Actual Cartons',
    packingMethod: 'Packing Method',
    hsCodeLine: 'Customs Code',
    cnDesc: 'Chinese Description',
    enDesc: 'English Description',
    customsDecl: 'Customs Declaration',
    amountOrigin: 'Original Amount',
    unitPriceOrigin: 'Original Unit Price',
    unitPrice: 'Tax-included Unit Price',
    unitPriceNet: 'Tax-excluded Unit Price',
    amtnNet: 'Net Amount',
    amtnFh: 'Tax-included Amount',
    tax: 'Tax Amount',
    taxRto: 'Tax Rate',
    unitPriceQg: 'Clearance Tax-excluded Unit Price',
    amountNetQg: 'Clearance Tax-excluded Amount',
    amountTaxQg: 'Clearance Tax Amount',
    amountAllQg: 'Clearance Tax-included Amount',
    currencyQg: 'Clearance Currency',
    unitPriceBg: 'Customs Tax-excluded Unit Price',
    amountNetBg: 'Customs Tax-excluded Amount',
    amountTaxBg: 'Customs Tax Amount',
    amountAllBg: 'Customs Tax-included Amount',
    currencyBg: 'Customs Currency',
    cusPoNo: 'Customer PO No.',
    multiCurrency: '(Multiple Currencies)'
  },
  productSummary: {
    totalQuantity: 'Total Quantity',
    productAmount: 'Product Amount',
    totalTax: 'Total Tax',
    customsAmount: 'Customs Value',
    clearanceAmount: 'Clearance Value'
  },
  split: {
    title: 'Split Transport Plan',
    rule: 'Split Rule',
    full: 'Full Split',
    partial: 'Partial Split',
    sku: 'SKU',
    productName: 'Product Name',
    order: 'Order',
    currentPlan: 'Current Plan',
    newPlan: 'New Plan {index}',
    qty: 'Qty',
    boxQty: 'Cartons'
  },
  generateConsignment: {
    title: 'Generate Transport Consignment',
    selectedHint: '{count} selected',
    groupName: 'Consignment {index}',
    rules: {
      title: 'Merge Rules',
      full: '1. Base match: transport segment, segment origin, and segment destination must match; express and customer-appointed plans stay separate',
      segment: '2. Address match: validate shipper for any pre-port leg and consignee for any last-mile leg; pure main-line plans skip door-address validation',
      express: '3. A missing plan address falls back to the same FH shipment request; if both sources are missing, the plan stays separate',
      single: '4. Address comparison uses location and postcode fields with outer whitespace trimmed; contact differences still merge and use the lowest-FH plan with a warning'
    },
    summary: {
      selected: 'Selected Plans',
      customerSpecified: 'Customer Appointed',
      express: 'Express',
      willGenerate: 'Expected',
      unit: 'consignments'
    },
    table: {
      consignment: 'Consignment',
      remark: 'Remark'
    },
    selectableOnly: 'Only plans whose main status is Created and whose child consignment is Not Created can be selected',
    detailLoadFailed: 'Some transport plan details failed to load; package totals may be incomplete',
    previewLoadFailed: 'Merge preview failed to load. Plans are temporarily shown separately; actual generation still follows backend rules',
    reasons: {
      customerSpecified: 'Customer Appointed',
      express: 'Express'
    }
  },
  drawer: {
    consignmentTitle: 'Transport Consignment: {no}'
  },
  messages: {
    loadListFailed: 'Failed to load transport plan list',
    idRequired: 'Transport plan ID is required',
    loadDetailFailed: 'Failed to load transport plan detail',
    distributionShipmentNotFound: 'Shipment request [{no}] was not found; its details cannot be opened',
    distributionShipmentOpenFailed: 'Failed to open shipment request details, please try again',
    transportConsignmentNotFound: 'Transport consignment [{no}] was not found; its details cannot be opened',
    transportConsignmentOpenFailed: 'Failed to open transport consignment details, please try again',
    editCreatedOnly: 'Only transport plans with Created main status can be edited',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Failed to save transport plan',
    printInfo: 'Print transport plan',
    splitSuccess: 'Split successfully',
    selectPlanFirst: 'Please select transport plans first',
    generateConsignmentTodo: 'Transport consignment generation logic is pending',
    generateConsignmentSuccess: 'Transport consignments generated: {nos}',
    generateConsignmentSuccessCopied: 'Transport consignments generated and copied to clipboard: {nos}',
    generateConsignmentCopyFailed: 'Failed to copy consignment numbers automatically; please copy them manually',
    generateConsignmentFailed: 'Failed to generate transport consignments',
    splitQtyExceeded: '{name} quantity exceeds order quantity (order {orderQty}, entered {totalQty}); please adjust and try again',
    splitBoxExceeded: '{name} cartons exceed order quantity (order {orderQty}, entered {totalQty}); please adjust and try again'
  }
}
